import clsx from 'clsx';
import type { FunctionComponent, SVGProps } from 'react';

type VoiceIconProps = SVGProps<SVGSVGElement> & {
    readonly isAnimating?: boolean;
};

export const VoiceIcon: FunctionComponent<VoiceIconProps> = ({ isAnimating = false, ...props }) => (
    // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
    <svg {...props} viewBox="0 0 13 12">
        <line
            className={clsx('origin-center', isAnimating && 'animate-voice-pulse-1')}
            stroke="currentColor"
            strokeLinecap="round"
            x1="2.25"
            x2="2.25"
            y1="4.75"
            y2="7.25"
        />
        <line
            className={clsx('origin-center', isAnimating && 'animate-voice-pulse-2 [animation-delay:0.1s]')}
            stroke="currentColor"
            strokeLinecap="round"
            x1="4.25"
            x2="4.25"
            y1="1.75"
            y2="10.25"
        />
        <line
            className={clsx('origin-center', isAnimating && 'animate-voice-pulse-3 [animation-delay:0.05s]')}
            stroke="currentColor"
            strokeLinecap="round"
            x1="6.5"
            x2="6.5"
            y1="3.75"
            y2="8.25"
        />
        <line
            className={clsx('origin-center', isAnimating && 'animate-voice-pulse-4 [animation-delay:0.15s]')}
            stroke="currentColor"
            strokeLinecap="round"
            x1="8.75"
            x2="8.75"
            y1="2.75"
            y2="9.25"
        />
        <line
            className={clsx('origin-center', isAnimating && 'animate-voice-pulse-5 [animation-delay:0.08s]')}
            stroke="currentColor"
            strokeLinecap="round"
            x1="10.75"
            x2="10.75"
            y1="4.75"
            y2="7.25"
        />
    </svg>
);
